import React, { lazy } from 'react';
import { motion } from 'framer-motion';
interface OrderBumpProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}
export function OrderBump({
  checked,
  onChange
}: OrderBumpProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="w-full max-w-md mx-auto" data-id="element-132">
      <div className="rounded-xl border-2 border-[#FFD700] bg-black p-5 shadow-[0_0_20px_rgba(255,215,0,0.15)] flex flex-col gap-3" data-id="element-133">
        {/* Header: Image + Title + Price */}
        <div className="flex items-start gap-3" data-id="element-134">
          <div className="flex-shrink-0 w-14 h-14 rounded-lg overflow-hidden bg-gray-800" data-id="element-135">
            <img src="https://cdn.magicpatterns.com/uploads/qyoN8PHt3HvP9gk6Zb92Y9/order_bump1.png" alt="21 Guiones Magnéticos" loading="lazy" decoding="async" width={56} height={56} className="w-full h-full object-cover" data-id="element-136" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-137">
            <h4 className="text-[#FFD700] font-extrabold text-sm leading-tight tracking-tight" data-id="element-138">
              21 GUIONES MAGNÉTICOS™
            </h4>
            <div className="flex items-center gap-1.5 mt-1" data-id="element-139">
              <span className="text-slate-500 line-through text-[11px]" data-id="element-140">
                $21.00
              </span>
              <span className="text-[#FFD700] font-extrabold text-base" data-id="element-141">
                $7.00
              </span>
            </div>
          </div>
        </div>

        {/* Persuasion text */}
        <p className="text-slate-300 text-xs leading-relaxed" data-id="element-142">
          ¿Te da miedo qué decir cuando alguien te pregunta de qué trata tu
          negocio? No dejes que el esfuerzo de atraer prospectos se pierda por
          no saber cerrar la conversación. Con este{' '}
          <strong className="text-[#FFD700]" data-id="element-143">"Cargador de DMs"</strong> tendrás
          las palabras exactas para llevar a cualquier interesado de Instagram a
          una presentación por Zoom o WhatsApp sin parecer desesperado.
        </p>
        <p className="text-slate-500 text-[10px] italic" data-id="element-144">
          (Oferta única: Solo disponible en esta página. Ahorra un 67% del
          precio original)
        </p>

        {/* Checkbox action */}
        <div className="pt-3 border-t border-[#FFD700]/30" data-id="element-145">
          <label className="flex items-center gap-2 cursor-pointer group" onClick={e => {
          e.stopPropagation();
          onChange(!checked);
        }} data-id="element-146">
            <div className="flex-shrink-0" data-id="element-147">
              <motion.div animate={{
              boxShadow: checked ? '0 0 0 0 rgba(255,215,0,0)' : ['0 0 0 0 rgba(255,215,0,0.3)', '0 0 0 5px rgba(255,215,0,0)']
            }} transition={{
              duration: 1.4,
              repeat: checked ? 0 : Infinity,
              repeatType: 'loop'
            }} className="rounded" data-id="element-148">
                <div className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-all ${checked ? 'bg-[#FFD700] border-[#FFD700]' : 'bg-black border-[#FFD700]/50 group-hover:border-[#FFD700]'}`} data-id="element-149">
                  {checked && <motion.svg initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} className="w-3 h-3 text-black" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-150">
                      <polyline points="20 6 9 17 4 12" data-id="element-151" />
                    </motion.svg>}
                </div>
              </motion.div>
            </div>
            <span className="text-white font-bold text-xs leading-tight" data-id="element-152">
              ✅ ¡SÍ! AGREGAR POR SOLO $7.00
            </span>
          </label>
        </div>
      </div>
    </motion.div>;
}